import { render, staticRenderFns } from "./SocialTrainingForm.vue?vue&type=template&id=0e1fa7e4&scoped=true&lang=html&"
import script from "./SocialTrainingForm.vue?vue&type=script&lang=js&"
export * from "./SocialTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialTrainingForm.vue?vue&type=style&index=0&id=0e1fa7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fa7e4",
  null
  
)

export default component.exports